import React, { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import Masonry from "react-masonry-css";
import { Link } from "react-router-dom";

import Spinner from "./Spinner/Spinner"
import Pagination from "./Pagination";

import "./Quotes.css";

const breakpointColumnsObj = {
  default: 3,
  1280: 3,
  1024: 2,
  768: 1,
};

const QuotesList = ({
  quotes,
  total,
  totalPages,
  currentPage,
  fetchQuotes,
  loading,
  query,
}) => {

  const [searched, setSearched] = useState(false);

  useEffect(() => {
    if (!loading) {
      setSearched(true)
    }
  }, [loading])

  if(loading) {
    return (<div><Spinner/></div>)
  } else {
  return (
    <div>
      <div>
        {currentPage ? (
          <div className="flex justify-center items-center">
            <h2 className="text-xl my-2 pr-6 border-r border-gray-500">
              <strong className="text-gray-600 text-xl">{total} </strong>
              <span className="text-gray-700 text-lg">{query ? `"${query}"` : null } Quotes</span>
            </h2>
            {currentPage && (
              <span className="text-lg text-gray-500 d-inline-block h-100 pl-6">
                Page <span className="font-bold">{currentPage} </span>
                <span>/ </span>
                <span className="font-bold">{totalPages} </span>
              </span>
            )}
          </div>
        ) : null}

        <Pagination
          total={total}
          totalPages={totalPages}
          currentPage={currentPage}
          fetchQuotes={fetchQuotes}
        >
        </Pagination>
        <CSSTransition in={searched} timeout={200} className="animated animatedFadeInUp fadeInUp" mountOnEnter unmountOnExit>
          <div>
            <ul className="quotes">
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >
                {quotes?.map((quote, index) => (
                  <li
                    key={index}
                    className="text-left my-8 bg-white rounded-lg"
                  >
                    <blockquote className="relative shadow-md hover:shadow-2xl transition duration-500 ease-in-out text-xl bg-neutral-100 text-neutral-600 border-neutral-800 quote">
                      <div className="bg-purple-500 h-2 w-full rounded-t-lg"></div>
                        <div className="p-6">

                        
                        <Link to={`/quote/${quote.id}`} className="relative z-10 mb-6">
                          {quote.body}
                        </Link>
                        <div className="stylistic-quote-mark text-gray-200 z-0 absolute top-3 left-2 leading-none" aria-hidden="true">
                          &ldquo;
                        </div>
                      <cite className="flex items-center mt-4">
                        <Link to={`/philosophers/${quote.author}`} className="fixed w-14 h-14 mr-3 overflow-hidden rounded-full">
                          {quote.author === 'Marcus Aurelius' ? 
                          ( 
                            <img alt="Marcus Aurelius"
                            src="https://upload.wikimedia.org/wikipedia/commons/c/c5/Marcus_Aurelius_Metropolitan_Museum.png" />
                          )
                          :
                          (quote.author === 'Seneca' ? 
                          ( 
                            <img alt="Seneca"
                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/0_S%C3%A9n%C3%A8que_-_Mus%C3%A9e_du_Prado_-_Cat._144_-_%282%29.JPG/1024px-0_S%C3%A9n%C3%A8que_-_Mus%C3%A9e_du_Prado_-_Cat._144_-_%282%29.JPG" />
                          ) 
                          : 
                          ( 
                            <img alt="Epictetus"
                            src="https://upload.wikimedia.org/wikipedia/commons/9/90/Epictetus.jpg" />
                          ))}
                        </Link>
                        <div className="ml-16 flex flex-col items-start">
                          <Link
                            to={`/philosophers/${quote.author}`}
                            className="text-lg font-bold hover:underline"
                          >
                            {quote.author}
                          </Link>
                          <div className="text-base">
                          {quote.quotesource}
                          </div>
                        </div>
                      </cite>
                      <div className="border-t border-gray-200 mt-4 text-center">
                        {quote.keywords.slice(0, 4).map((keyword, index) => (
                          <Link
                            to={`/topics/${keyword}`}
                            key={index}
                            className="inline-block m-1 text-sm py-2 px-3 rounded-full bg-gray-200 hover:bg-gray-300 mt-4 text-gray-800"
                          >
                            <div className="font-normal leading-none flex-initial ">
                              {keyword}
                            </div>
                          </Link>
                        ))}
                      </div>
                      </div>
                    </blockquote>
                  </li>
                ))}
              </Masonry>
            </ul>
            <Pagination
              total={total}
              totalPages={totalPages}
              currentPage={currentPage}
              fetchQuotes={fetchQuotes}
            ></Pagination>
          </div>
        </CSSTransition>
      </div>
    </div>
    );
  }
};

export default QuotesList;
